import { SimplifiedSupplier } from "@core/model/supplier/supplier-model";

export interface UserPreferencesModel {
  id?: number,
  organizationId?: number;
  defaultApoSupplier?: SimplifiedSupplier;
  defaultNapoSupplier1?: SimplifiedSupplier;
  defaultNapoSupplier2?: SimplifiedSupplier;
  defaultNapoSupplier3?: SimplifiedSupplier;
}

export interface DefaultNapoSupplierApiResponse {
  organizationId: number;
  organizationName: string;
  organizationAddress: string;
  salesPrice: string;
  isImportedNapo: string;
}

export class UserPreferences implements UserPreferencesModel {
  id ?= -1;
  organizationId ?= -1;
  defaultApoSupplier ?= new SimplifiedSupplier();
  defaultNapoSupplier1 ?= new SimplifiedSupplier();
  defaultNapoSupplier2 ?= new SimplifiedSupplier();
  defaultNapoSupplier3 ?= new SimplifiedSupplier();

  constructor(dto?: UserPreferencesModel) {
    if (!dto) {
      return
    }
    this.id = dto.id;
    this.organizationId = dto.organizationId;
    this.defaultApoSupplier = dto.defaultApoSupplier;
    this.defaultNapoSupplier1 = dto.defaultNapoSupplier1;
    this.defaultNapoSupplier2 = dto.defaultNapoSupplier2;
    this.defaultNapoSupplier3 = dto.defaultNapoSupplier3;
  }
}
